export default {
      id: "map__car_type_police-car-usage",
      viewBox: "0 0 29 22",
      url: __webpack_public_path__ + "img/icons.svg#map__car_type_police-car",
      toString: function () {
        return this.url;
      }
    }